$(function () {
    $('.site_banner__search_form #product-name').change(function () {
        $('.site_banner__search_form__button_wrap .button').attr('href', $(this).children("option:selected").val());
    })
});